module.exports = __webpack_public_path__ + "static/media/basicPlanWandaIcon.8d23afec.svg";